import { useQuery } from "react-query";

import { filterDeactivatedJsonPrices } from "../../../utils/PricelistUtils";
import { Price } from "../../../utils/types";
import { useGetLivePricelistUpdates } from "../../../utils/Websocket";
import { fetch_horeca_prices_v1, fetch_pricelist_prices_v1, fetch_pricelist_prices_v2 } from "../../Client";

export const useFetchPricelistPrices = (shopId: string, screenId?: string) => {
    const queryKey = "pricelistShow-" + shopId;
    useGetLivePricelistUpdates(shopId, queryKey);
    return useQuery<Price[]>(
        [queryKey],
        async () => {
            const base = screenId
                ? await fetch_pricelist_prices_v2(shopId, screenId)
                : await fetch_pricelist_prices_v1(shopId);
            const cannabis = filterDeactivatedJsonPrices(base?.prices ?? []);

            const isExtraPage = window.location.pathname.includes("extra");

            if (isExtraPage) {
                const filtered = cannabis
                    .filter((price: Price) => price.active)
                    .filter(
                        (price: Price) =>
                            price.category_name.toLowerCase() === "edibles" ||
                            price.category_id === "9a1d6ba6-79cc-412b-be47-ac30772cda9b"
                    );

                const horeca = await fetch_horeca_prices_v1(shopId!);
                const horecaCannabis = filterDeactivatedJsonPrices(horeca?.prices ?? []);

                return filtered.concat(horecaCannabis.filter((price: Price) => price.active));
            }

            if (screenId) {
                return cannabis.filter((price: Price) => price.active);
            }
            return cannabis
                .filter((price: Price) => price.active)
                .filter((price: Price) => price.category_name.toLowerCase() !== "edibles")
                .filter((price: Price) => price.category_id !== "9a1d6ba6-79cc-412b-be47-ac30772cda9b");
        },
        {
            enabled: !!shopId,
        }
    );
};
